function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  stroke: "#fff",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2
}, /*#__PURE__*/React.createElement("path", {
  d: "M2.121 21.634l13.938 13.938 13.938-13.938M2.121 2.121l13.938 13.938L29.997 2.121"
}));

function SvgChevronsDown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32.119,
    height: 37.073,
    viewBox: "0 0 32.119 37.073"
  }, props), _ref);
}

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIzMi4xMTkiIGhlaWdodD0iMzcuMDczIiB2aWV3Qm94PSIwIDAgMzIuMTE5IDM3LjA3MyI+PGcgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTguMzc5IC02Ljg3OSkiPjxwYXRoIGQ9Ik0xMC41LDE5LjUsMjQuNDM4LDMzLjQzOCwzOC4zNzYsMTkuNSIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMCA5LjAxMykiIGZpbGw9Im5vbmUiIHN0cm9rZT0iI2ZmZiIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIiBzdHJva2Utd2lkdGg9IjIiLz48cGF0aCBkPSJNMTAuNSw5LDI0LjQzOCwyMi45MzgsMzguMzc2LDkiIGZpbGw9Im5vbmUiIHN0cm9rZT0iI2ZmZiIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIiBzdHJva2Utd2lkdGg9IjIiLz48L2c+PC9zdmc+";
export { SvgChevronsDown as ReactComponent };